<div class="icon-container">
  <bp-icon size="{{ iconSize }}" theme="regular" [icon]="icon"></bp-icon>
</div>
<div class="error-text">
  @if (title) {
    <div class="error-title">{{ title }}</div>
  }
  @if (message) {
    <div class="error-message">{{ message }} </div>
  }
</div>
@if (tryAgainMessage) {
  <bp-button (click)="tryAgainClicked()" size="small" variant="secondary">
    {{ tryAgainMessage | translate }}
    @if(showTryAgainIcon) {
      <bp-icon size="20" slot="end" icon="arrow-repeat-all"></bp-icon>
    }
  </bp-button>
}
